import { clearPhone } from './clearPhone';

export const preparePhone = (phone: string): string => `+${clearPhone(phone)}`;
